<template>
    <b-field grouped class="field-wrapper">
      <b-field label="Name">
        <contact-search  v-if="hasContactSearch"
                         :disabled="$attrs['disabled']"
                         :company-location="$attrs['company-location']"
                         @selected="populate" v-model="contact.name"
                         @keyup.native="clearContactKey" />
        <carrier-search v-else-if="hasCarrierSearch" @selected="populate" v-model="contact.name" @keyup.native="clearContactKey" :disabled="$attrs['disabled']" />
        <b-input v-else v-model="contact.name" autocomplete="off" :disabled="$attrs['disabled']" />
      </b-field>

      <b-field label="Phone">
        <phone-number-input v-model="contact.phone" @keyup.native="clearContactKey" :disabled="$attrs['disabled']" />
      </b-field>

      <b-field label="Email">
        <b-input v-model="contact.email" autocomplete="off" @keyup.native="clearContactKey" :disabled="$attrs['disabled']" />
      </b-field>

    </b-field>
</template>

<script>
import { isEqual } from 'lodash-es'
import hasEmptyValues from '@/helpers/hasEmptyValues'
import PhoneNumberInput from '@/components/PhoneNumberInput'
// import ContactSearch from '@/components/RolodexContactSearch'
// import CarrierSearch from '@/components/RolodexCarrierSearch'

export default {
  name: 'ContactForm',

  props: {
    contactType: {
      type: String,
      default: 'none',
      validator: function(value) {
        const validTypes = ['contact', 'carrier', 'none']
        return validTypes.includes(value.toLowerCase())
      }
    },
    canSearch: {
      type: Boolean,
      default: true
    },
    value: {
      type: Object,
      default: () => ({ companyRolodexContactKey: null, name: '', phone: '', email: '' })
    },
    removeKeyOnUpdate: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    hasContactSearch() {
      return this.contactType === 'contact' && this.canSearch
    },

    hasCarrierSearch() {
      return this.contactType === 'carrier' && this.canSearch
    }
  },

  created() {
    // make a local copy of the prop data that was passed in so that when we change it... we change the local data.
    // any changes to this data will be sent back to the parent via an event
    this.contact = Object.assign({}, this.value)
  },

  components: {
    PhoneNumberInput,
    ContactSearch: () => import('@/components/RolodexContactSearch.vue'),
    CarrierSearch: () => import('@/components/RolodexCarrierSearch.vue')
  },

  data() {
    return {
      contact: { name: '', phone: null, email: '', companyRolodexContactKey: null }
    }
  },

  methods: {
    /**
     * Resets the `companyRolodexContactKey` to null.
     * This is needed in case the user selects an existing contact but then modifies the information (like change the
     * name or email address). In such cases we need to treat it as a new contact.
     */
    clearContactKey() {
      if (this.removeKeyOnUpdate) {
        this.contact.companyRolodexContactKey = null
      }
    },

    populate(selectedContact) {
      if (this.hasContactSearch) {
        const phone = selectedContact.companyRolodexContactPhones[0]
        this.contact = {
          name: selectedContact.companyRolodexContactFullName,
          phone: phone ? phone.companyRolodexContactPhoneDigits : null,
          email: selectedContact.companyRolodexContactEmailAddress,
          companyRolodexContactKey: selectedContact.companyRolodexContactKey
        }
      } else if (this.hasCarrierSearch) {
        const phone = selectedContact.accountPhones[0]
        this.contact = {
          name: `${selectedContact.accountFirstName} ${selectedContact.accountLastName}`,
          phone: phone ? phone.accountPhoneDigits : null,
          email: selectedContact.accountEmailAddress,
          accountKey: selectedContact.accountKey
        }
      }
    }
  },

  watch: {
    value: {
      deep: true,
      handler() {
        const defaults = { companyRolodexContactKey: null, name: '', phone: '', email: '' }

        if (!isEqual(this.value, this.contact)) {
          this.contact = hasEmptyValues(this.value) ? defaults : this.value
        }
      }
    },

    contact: {
      deep: true,
      handler() {
        let valueToEmit = this.contact

        // if the contact is all empty values... just send back null
        if (!hasEmptyValues(valueToEmit)) {
          valueToEmit = null
        }

        this.$emit('input', this.contact)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.field-wrapper {
  display: flex;

  .field {
    flex: 1;
  }
}
</style>
